/**
 *
 * Ask
 *
 */

import { mapState, mapGetters, mapMutations } from 'vuex';

export const QaTagsModelMixin = {
  name: 'QaTagsModelMixin',

  data: () => {
    return {};
  },

  computed: {
    ...mapState('Mixins/QA', {
      ms_qAskTags: 'qAskTags',
      ms_selectedTagId: 'selectedTagId',
      ms_selectedSubTagId: 'selectedSubTagId',
    }),

    ...mapGetters('Mixins/QA', {
      mg_isSelectedTag: 'isSelectedTag',
      mg_selectedTag: 'selectedTag',
      mg_isNeedSubTag: 'isNeedSubTag',
      mg_isSelectedSubTag: 'isSelectedSubTag',
    }),
  },

  methods: {
    ...mapMutations('Mixins/QA', {
      mm_SET_SELECTED_TAG_ID: 'SET_SELECTED_TAG_ID',
      mm_SET_SELECTED_SUBTAG_ID: 'SET_SELECTED_SUBTAG_ID',
    }),
  },
};

export default QaTagsModelMixin;
